import React from 'react';

interface Identified {
  id?: React.Key | null;
}

// TypeScript can't prove that Props minus id is still Props for a generic Props, hence the cast.
export const withReactKey =
  <Props extends object>(Component: React.ComponentType<Props>) =>
  ({ id, ...props }: Props & Identified, index: number): React.ReactElement =>
    <Component key={id ?? index} {...(props as Props)} />;
